"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import * as Aria from 'react-aria-components';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import invariant from 'invariant';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { EmulatedBoldText } from '../EmulatedBoldText/EmulatedBoldText.mjs';
import { Wrap } from '../Wrap/Wrap.mjs';
import clsx from 'clsx';
import styles from './Text.module.scss.mjs';

const Text = flowComponent("Text", (props) => {
  const {
    children,
    className,
    elementType = "span",
    emulateBoldWidth,
    ref,
    color,
    align = "start",
    wrap,
    style: styleFromProps,
    whiteSpace,
    wordBreak,
    ...rest
  } = props;
  const rootClassName = clsx(
    styles.text,
    color && styles[color],
    align && styles[`align-${align}`],
    wrap && styles[`wrap-${wrap}`],
    className
  );
  const textProps = { ...rest, className: rootClassName };
  const propsContext = {
    Link: {
      inline: true
    },
    Icon: { className: styles.icon }
  };
  const style = { whiteSpace, wordBreak, ...styleFromProps };
  const childrenElement = /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx(Wrap, { if: emulateBoldWidth, children: /* @__PURE__ */ jsx(EmulatedBoldText, { children }) }) });
  if (!props.slot) {
    const Element = elementType;
    return /* @__PURE__ */ jsx(Element, { style, ...textProps, ref, children: childrenElement });
  }
  invariant(
    typeof elementType === "string",
    "'elementType' in Text component must be of type string"
  );
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(
    Aria.Text,
    {
      style,
      ...textProps,
      elementType,
      ref,
      children: childrenElement
    }
  ) });
});

export { Text, Text as default };
//# sourceMappingURL=Text.mjs.map
